import DocumentState from '../shared/model/DocumentState';
import { OutsourceListMode } from '../my-outsources/outsource/list/OutsourceListMode';
import { OutsourceState } from '../shared/model/OutsourceState';
import { MessageState } from '../shared/model/MessageState';
import { WorkState } from '../shared/model/WorkState';

const commonDashboard = {
    outsourceDocs: {
        search: '',
        filter: DocumentState.ALL,
        collapsed: true,
    },
    workerDocs: {
        search: '',
        filter: DocumentState.ALL,
        collapsed: true,
    },
    machineDocs: {
        search: '',
        filter: DocumentState.ALL,
        collapsed: true,
    },
    monthlyDocs: {
        search: '',
        filter: DocumentState.ALL,
        collapsed: true,
    },
    linkedDocs: {
        search: '',
        filter: DocumentState.ALL,
        collapsed: true,
    },
    monthlyLinkedDocs: {
        search: '',
        filter: DocumentState.ALL,
        collapsed: true,
    },
    works: {
        search: '',
        filter: WorkState.ALL,
        collapsed: true,
    },
    messages: {
        search: '',
        filter: MessageState.ALL,
        collapsed: true,
    },
    company: {
        collapsed: true,
    },
};

class DashboardStorageManager {

    static KEY = 'DASHBOARD';
    static INSTANCE = new DashboardStorageManager();

    _dashboard = {
        myContractors: {
            ...commonDashboard,
            contractors: {
                search: '',
                collapsed: true,
            },
        },
        myOutsources: {
            ...commonDashboard,
            outsources: {
                mode: OutsourceListMode.GRID,
                search: '',
                filter: OutsourceState.ALL,
                collapsed: true,
            },
        },
    };

    static getInstance() {
        return DashboardStorageManager.INSTANCE;
    }

    init() {
        const documents = sessionStorage.getItem(DashboardStorageManager.KEY);
        if ( documents ) this._dashboard = JSON.parse(documents);
    }

    readCard(my, card) {
        return this._dashboard[my][card];
    }

    saveCard(my, card, state) {
        const prevState = this.readCard(my, card);
        this._dashboard[my][card] = { ...prevState, ...state };
        this._save();
    }

    saveDocCardFilter(my, filter) {
        const myDashboard = this._dashboard[my];
        myDashboard.outsourceDocs.filter = filter;
        myDashboard.workerDocs.filter = filter;
        myDashboard.machineDocs.filter = filter;
        myDashboard.monthlyDocs.filter = filter;
        myDashboard.monthlyLinkedDocs.filter = filter;
        myDashboard.linkedDocs.filter = filter;
        this._save();
    }

    _save() {
        sessionStorage.setItem(DashboardStorageManager.KEY, JSON.stringify(this._dashboard));
    }

    clear() {
        sessionStorage.clear();
    }
}

export const DashboardStorageManagerInstance = DashboardStorageManager.getInstance();



// WEBPACK FOOTER //
// ./src/app/dashboard/DashboardStorageManager.js